import React, { useMemo } from 'react';
import SimpleTable from '../../../../../components/SimpleTable';
import { TableTypes } from '../../../../../components/Table/constants';
import {
  TicketFilterOptionsSelector,
  TicketsLoadingStateSelector,
  TicketsSelector,
} from '../../../../../store/tickets/selectors';
import { useAppSelector } from '../../../../../store/hooks';
import { PortalConfigSelector } from '../../../../../store/config/selectors';
import TicketChatIcon from './TicketChatIcon';
import { ITicket } from '../../../../../services/tickets/types';
import useStyles from '../../../styles';
import TicketTitle from './TicketTitle';
import { PsaTicketFieldNames } from '../../../../../services/tickets/constants';

const TicketsTable: React.FC = () => {
  const classes = useStyles();
  const tickets = useAppSelector(TicketsSelector);
  const isTicketsLoading = useAppSelector(TicketsLoadingStateSelector);
  const config = useAppSelector(PortalConfigSelector);
  const { closeStatusId } = useAppSelector(TicketFilterOptionsSelector);
  const columns = useMemo(() => {
    const clm = [
      {
        name: 'Ticket ID',
        key: 'id',
        width: 150,
        minWidth: 150,
        type: TableTypes.custom,
        accessor: (row: ITicket) => <TicketTitle ticket={row} />,
      },
      {
        name: 'Summary',
        key: 'title',
        minWidth: 150,
      },
      {
        name: 'Contact',
        key: PsaTicketFieldNames[config.psaType].contact,
        minWidth: 150,
      },
      {
        name: 'Customer',
        key: 'company',
        type: TableTypes.custom,
        accessor: (row: ITicket) =>
          row.siteName
            ? `${row[PsaTicketFieldNames[config.psaType].company as 'company']}/${row.siteName}`
            : row[PsaTicketFieldNames[config.psaType].company as 'company'],
        minWidth: 150,
      },
      {
        name: 'Status',
        key: 'status',
        width: 150,
        minWidth: 150,
      },
      {
        name: 'Action',
        key: 'action',
        type: TableTypes.custom,
        accessor: (row: ITicket) => (
          <div className={classes.chatButtonWrapper}>
            <TicketChatIcon
              chatId={row.chatId}
              ticketId={row.id}
              ticketNumber={row.ticketNumber}
              isTicketClosed={+row.statusId === +closeStatusId}
            />
          </div>
        ),
        width: 75,
        minWidth: 75,
      },
    ];
    if (config.disableChats) {
      clm.splice(-1);
    }
    return clm;
  }, [closeStatusId, config]);
  return (
    <SimpleTable
      data={tickets}
      columns={columns}
      loading={isTicketsLoading}
      className={classes.table}
    />
  );
};

export default TicketsTable;
